import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Clock, MousePointer, GitBranch, Play, Bell, Flag, Truck, MessageSquare, Timer, Link2, Webhook, Terminal } from 'lucide-react';
import { NODE_TYPES, NODE_STYLES, TRIGGER_PALETTE_ITEMS, CONDITION_PALETTE_ITEMS, ACTION_PALETTE_ITEMS } from '../../constants';

const iconMap = {
  Zap, Clock, MousePointer, GitBranch, Play, Bell, Flag, Truck, MessageSquare, Timer, Link2, Webhook, Terminal,
};

const PaletteItem = ({ item }) => {
  const Icon = iconMap[item.iconName] || Play;
  const borderColor = NODE_STYLES[item.nodeType]?.borderColor || 'border-gray-200';

  const onDragStart = (event) => {
    event.dataTransfer.setData('application/reactflow/type', item.nodeType);
    if (item.subtype) {
      event.dataTransfer.setData('application/reactflow/subtype', item.subtype);
    }
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg border-2 ${borderColor} bg-white cursor-grab hover:shadow-md transition-shadow active:cursor-grabbing select-none outline-none focus:outline-none`}
      onDragStart={onDragStart}
      draggable
    >
      <Icon size={16} className="shrink-0 text-gray-600" />
      <div className="min-w-0">
        <div className="text-sm font-medium truncate">{item.label}</div>
        {item.description && <div className="text-[10px] text-gray-400 truncate">{item.description}</div>}
      </div>
    </div>
  );
};

const NodePalette = ({ actionTypes = [] }) => {
  // Merge API action types that aren't already in our hardcoded list
  const knownSubtypes = ACTION_PALETTE_ITEMS.map(a => a.subtype);
  const extraActions = actionTypes
    .filter(a => !knownSubtypes.includes(a.type || a.value))
    .map(a => ({
      nodeType: NODE_TYPES.ACTION,
      subtype: a.type || a.value,
      label: a.label || a.type || a.value,
      description: a.description || '',
      iconName: 'Play',
    }));

  const allActionItems = [...ACTION_PALETTE_ITEMS, ...extraActions];

  return (
    <div className="w-56 bg-white border-r overflow-y-auto p-4 space-y-5">
      <Link to="/automation-engine" className="text-xs font-medium text-gray-400 hover:text-gray-700 tracking-wide uppercase transition-colors">
        Automation Dashboard
      </Link>
      <h1 className="text-lg font-bold uppercase text-gray-900 pb-3 border-b">Components</h1>
      <div>
        <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider mb-2">Triggers</h3>
        <div className="space-y-2">
          {TRIGGER_PALETTE_ITEMS.map(item => (
            <PaletteItem key={item.subtype} item={item} />
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider mb-2">Conditions</h3>
        <div className="space-y-2">
          {CONDITION_PALETTE_ITEMS.map(item => (
            <PaletteItem key={item.label} item={item} />
          ))}
        </div>
      </div>

      <div>
        <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wider mb-2">Actions</h3>
        <div className="space-y-2">
          {allActionItems.map(item => (
            <PaletteItem key={item.subtype} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default NodePalette;
